import type { TariffPlans } from '@/types'

const proFeatures = {
  name: 'Pro',
  description: 'For individuals',
  paymentType: {
    monthly: 'per month',
    annual: 'per month billed yearly',
  },
  features: ['1 user', '8 projects', 'Unlimited editors'],
  additional_features: [
    'Branding',
    'Symbols',
    'Figma sync',
    'SEO tools',
    'Google Analytics',
    'Export',
    'Image mode',
    'Activity history',
    'Password protect',
    'Guest comments',
  ],
  color: '#18c4a9',
  projects: '8',
  members: '1',
}

const teamLegacyFeatures = {
  name: 'Team',
  description: 'For business of any size',
  paymentType: {
    monthly: 'per month',
    annual: 'per month billed yearly',
  },
  features: ['Seat based plan', '32 projects', 'Unlimited editors'],
  additional_features: [
    'All Pro features',
    'Team workspace',
    'Project folders',
    'Shared symbol library',
    'Team roles',
    'Assign / Resolve',
    'Access restriction',
    'Priority support',
  ],
  color: '#2f7fef',
  projects: '32',
  members: 'Unlimited',
}

const teamPerSeatFeatures = {
  ...teamLegacyFeatures,
  paymentType: {
    monthly: 'per user/month',
    annual: 'per user/month billed yearly',
  },
  features: ['Seat based plan', 'Unlimited projects', 'Unlimited editors'],
  projects: 'Unlimited',
  members: 'Unlimited',
}

const agencyFeatures = {
  name: 'Agency',
  description: 'For business of any size',
  paymentType: {
    monthly: 'per month',
    annual: 'per month billed yearly',
  },
  features: ['Seat based plan', 'Unlimited projects', 'Unlimited editors'],
  additional_features: [
    'All Pro features',
    'Team workspace',
    'Project folders',
    'Shared symbol library',
    'Team roles',
    'Assign work',
    'Access restriction',
  ],
  color: '#4d607c',
  projects: 'Unlimited',
  members: 'Unlimited',
}

export const planTypes: TariffPlans = {
  plan_free: {
    isLegacy: false,
    id: 'plan_free',
    name: 'Free',
    description: 'Get started',
    price: {
      monthly: 0,
      annual: 0,
    },
    paymentType: {
      monthly: '',
      annual: '',
    },
    features: ['1 user', '1 project', 'Unlimited editors'],
    additional_features: [],
    color: '#acbdd3',
    projects: '1',
    members: '1',
  },
  plan_pro: {
    isLegacy: true,
    id: 'plan_pro',
    ...proFeatures,
    price: {
      monthly: 10,
      annual: 8,
    },
  },
  plan_pro2: {
    isLegacy: true,
    id: 'plan_pro2',
    ...proFeatures,
    price: {
      monthly: 12,
      annual: 10,
    },
  },
  plan_pro3: {
    isLegacy: false,
    id: 'plan_pro3',
    ...proFeatures,
    price: {
      monthly: 16,
      annual: 14,
    },
  },
  plan_team: {
    isLegacy: true,
    id: 'plan_team',
    ...teamLegacyFeatures,
    price: {
      monthly: 40,
      annual: 34,
    },
  },
  plan_teamperseat: {
    isLegacy: true,
    id: 'plan_teamperseat',
    ...teamPerSeatFeatures,
    price: {
      monthly: 16,
      annual: 14,
    },
  },
  plan_team3seats: {
    isLegacy: true,
    id: 'plan_team3seats',
    ...teamPerSeatFeatures,
    price: {
      monthly: 48,
      annual: 42,
    },
    paymentType: {
      monthly: 'for 3 seats per month',
      annual: 'for 3 seats/month billed yearly',
    },
  },
  plan_teamperseat2: {
    isLegacy: false,
    id: 'plan_teamperseat2',
    ...teamPerSeatFeatures,
    price: {
      monthly: 24,
      annual: 20,
    },
  },
  plan_agency: {
    isLegacy: true,
    id: 'plan_agency',
    ...agencyFeatures,
    price: {
      monthly: 120,
      annual: 100,
    },
  },
}
